import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateProjectPersonasArgs, BackendProject } from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateProjectPersonas($projectId: ID!, $personaIds: [ID!]!) {
    updateProjectPersonas(projectId: $projectId, personaIds: $personaIds) {
      customerPersonas {
        id
      }
    }
  }
`;

type Variables = BackendMutationUpdateProjectPersonasArgs;
type Result = Pick<BackendProject, 'customerPersonas'>;

export const updateProjectPersonas = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
